module.exports = __webpack_public_path__ + "static/media/smileRating2.c3680acf.svg";